<template>
  <div
    class="layout-header"
    :style="{
      backgroundImage: `url(${currentLang === 'en' ? headerBgEN : headerBg})`,
      backgroundSize: '100% 100%',
    }"
  >
    <!--<div class="layout-header__label">
      <img class="layout-header__label__image" :src="logo" alt="" />
      <span class="layout-header__label__title">品河线锯数字化智能监控系统</span>
    </div>-->
    <div
      v-if="routePath == '/detail'"
      class="layout-header__back"
      @click="backToHome"
    >
      <i class="el-icon-d-arrow-left"></i> {{ $t("detailScreen.返回") }}
    </div>
    <div v-else class="layout-header__back">
      <div class="flexCenter">
        <span>{{ $t("bigScreen.语种") }}：</span>
        <img
          :src="currentLang === 'zh-CN' ? zhUnselected : zhSelected"
          alt=""
          @click="translate('zh-CN')"
        />
        <img
          :src="currentLang === 'en' ? enUnselected : enSelected"
          alt=""
          @click="translate('en')"
        />
      </div>
    </div>
    <div>
      <div class="layout-header__userinfo">
        <el-icon class="el-icon-user mrr-4"></el-icon
        >{{ userInfo.roles[0].roleName }} {{ userInfo.nickName }}
      </div>
      <div class="layout-header__time">{{ time }}</div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/images/logo.png";
import zhSelected from "@/assets/images/zhong-xz.png";
import zhUnselected from "@/assets/images/zhong-wxz.png";
import enSelected from "@/assets/images/ying-xz.png";
import enUnselected from "@/assets/images/ying-wxz.png";
import headerBg from "@/assets/images/headerBg.png";
import headerBgEN from "@/assets/images/headerBg-en.png";
import { getInfo } from "@/api/login";

export default {
  name: "layout-header",
  data() {
    return {
      logo,
      zhSelected,
      zhUnselected,
      enSelected,
      enUnselected,
      headerBg,
      headerBgEN,
      time: "",
      timer: null,
      routePath: "",
      currentLang: "", // 初始化时从i18n获取当前语言
      userInfo: {},
    };
  },

  watch: {
    // 监听路由变化
    $route: {
      handler(newRoute) {
        this.routePath = newRoute.path;
        // 同步当前语言状态
        this.currentLang = this.$i18n.locale;
      },
      immediate: true,
    },
    // 监听语言变化
    "$i18n.locale": {
      handler(newLocale) {
        this.currentLang = newLocale;
      },
      immediate: true,
    },
  },

  methods: {
    setTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();
      this.time =
        year +
        "-" +
        (month < 10 ? "0" : "") +
        month +
        "-" +
        (day < 10 ? "0" : "") +
        day +
        " " +
        (hours < 10 ? "0" : "") +
        hours +
        ":" +
        (minutes < 10 ? "0" : "") +
        minutes +
        ":" +
        (seconds < 10 ? "0" : "") +
        seconds;
    },
    backToHome() {
      this.$router.push({
        path: "/",
      });
    },
    translate(lang) {
      this.currentLang = lang;
      this.$i18n.locale = lang;
      // 触发父组件的数据更新
      this.$root.$emit("languageChanged");
    },
    getUserInfo() {
      getInfo().then((res) => {
        this.userInfo = res.user;
      });
    },
  },

  created() {
    this.getUserInfo();
    this.currentLang = this.$i18n.locale;
    this.setTime();
    this.timer = setInterval(this.setTime, 1000);
  },
  mounted() {},
  destroyed() {
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style lang="less" scoped>
.layout-header {
  position: relative;
  width: 100%;
  height: 80px;
  /*margin-bottom: 56px;*/
  display: flex;
  justify-content: center;

  &__label {
    display: flex;
    font-family: YouSheBiaoTiHei;
    font-size: 42px;
    color: #ffffff;
    line-height: 37px;
    letter-spacing: 7px;
    text-align: left;
    font-style: normal;
    font-weight: 700;
    margin-top: 16px;
    background: linear-gradient(180deg, #ffffff 0%, #73c2ff 100%);
    -webkit-background-clip: text; /*将设置的背景颜色限制在文字中*/
    -webkit-text-fill-color: transparent; /*给文字设置成透明*/
    &__image {
      width: 51px;
      height: 42px;
    }
    &__title {
      margin-left: 5px;
      //padding-bottom: 5px;
    }
  }
  &__time {
    width: fit-content;
    position: absolute;
    top: 30px;
    right: 2%;
  }
  &__userinfo {
    width: fit-content;
    position: absolute;
    top: 20px;
    right: 20%;
  }
  &__back {
    width: fit-content;
    position: absolute;
    top: 30px;
    left: 2%;
    cursor: pointer;
    font-size: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.8);
    }

    img {
      width: 20px;
      height: 20px;
      margin-left: 8px;
    }
  }
}
.mrr-4 {
  margin-right: 4px;
}
</style>
